import * as CONSTANTS from '../constants/constants';

const initialState = {
  loading: false,
  courses: [],
  drafts: [],
  course: {},
  sections: [],
  mycourses: [],
  lastViewCourse:{},
  coursePageError: false,
  courseGetSuccessful:false,

};

const getCourses = (state = initialState, action) => {
  switch (action.type) {
    case CONSTANTS.SHOWERROR_PAGE:
      return Object.assign({}, state, {
        coursePageError: true
      });
    case CONSTANTS.SET_LOADING:
      return Object.assign({}, state, {
        loading: true
      });
    case CONSTANTS.GET_COURSES:
      return Object.assign({}, state, {
        loading: false,
        courses: action.courses
      });
    case CONSTANTS.GET_MYCOURSES:
      // console.log(action.courses)
      return Object.assign({}, state, {
        loading: false,
        mycourses: action.courses
      });
    case CONSTANTS.GET_DRAFT_COURSES:
      return Object.assign({}, state, {
        loading: false,
        drafts: action.courses
      });
    case CONSTANTS.GET_COURSE:
      return Object.assign({}, state, {
        loading: false,
        course: action.course
      });
    case CONSTANTS.GET_SECTIONS:
      return Object.assign({}, state, {
        loading: false,
        courseGetSuccessful:true,
        sections: action.sections
      });
    case CONSTANTS.CLEAR_GET_COURSE:
        return Object.assign({}, state, {
          loading: false,
          courses: {},
          sections: [],
          courseGetSuccessful:false,
        });
    case CONSTANTS.GET_LECTURES:
      return Object.assign({}, state, {
        loading: false,
        courses: action.courses
      });
    case CONSTANTS.SET_LAST_VIEW_COURSE:
      return Object.assign({}, state, {
        lastViewCourse: action.payload,
      });
    case CONSTANTS.CLEAR_LAST_VIEW_COURSE:
      return Object.assign({}, state, {
        lastViewCourse: {}
      });
    default:
      return state;
  }
};
export default getCourses;
